import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from 'src/app/guards/auth.guard';
import { AthoraComponent } from './athora.component';

const routes: Routes = [
    {
        path: ':op',
        component: AthoraComponent,
        canActivate: [authGuard]
    }
]

@NgModule({
    imports: [RouterModule.forChild((routes))],
    exports: [RouterModule]
})
export class AthoraRoutingModule {
}
